import { Spinner } from '@cabonline/ui-shared';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { FC } from 'react';

const SpinnerSizes = {
  l: 60,
  m: 40,
  s: 20,
};

interface LoadingSpinnerProps {
  size?: keyof typeof SpinnerSizes;
  ariaLabel?: string;
}

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  @media (prefers-reduced-motion: no-preference) {
    animation: ${rotate} 2s linear infinite;
  }
`;

export const LoadingSpinner: FC<LoadingSpinnerProps> = ({ size = 'm', ariaLabel = 'Loading' }) => {
  const width = size === 'l' ? SpinnerSizes.l : size === 's' ? SpinnerSizes.s : SpinnerSizes.m;
  return (
    <StyledWrapper role="status" aria-label={ariaLabel}>
      <Spinner width={width} />
    </StyledWrapper>
  );
};
